import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  DIAM_API_PATH,
  DIAM_TEAM_ID,
  removeMembershipRole,
} from '../../diamApi';
import { useApiEssentials } from '../../../../shared/hooks/useApiEssentials';

export function useRemoveMembershipRole(identityId: string) {
  const { getIdToken, apiUrl } = useApiEssentials(DIAM_API_PATH);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (roleId: string) => {
      const idToken = await getIdToken();
      return removeMembershipRole(apiUrl, idToken, identityId, roleId);
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: ['diam', 'teams', DIAM_TEAM_ID, 'members', identityId],
      });
    },
  });
}
